var exports = {
  "wrapper": "xaee3c4fa--086ddc--wrapper",
  "_size_s": "xaee3c4fa--086ddc--_size_s",
  "_size_m": "xaee3c4fa--086ddc--_size_m",
};

module.exports = exports;
